import React from 'react';
import { Button } from '@etherisc/ui-kit';
import type { ButtonProps } from '@etherisc/ui-kit';

interface PrimaryButtonProps extends Omit<ButtonProps, 'variant' | 'children'> {
  children: React.ReactNode;
  loading?: boolean;
  loadingText?: string;
  type?: 'button' | 'submit' | 'reset';
  fullWidth?: boolean;
  wide?: boolean;
}

/**
 * Semantic button component for Primary actions
 * Uses BLUE color following UX guidelines for main actions on page/modal
 * Examples: Submit, Save, Next, Continue
 * Includes built-in loading state management
 * Uses @etherisc/ui-kit Button with variant="primary"
 */
export function PrimaryButton({ 
  children, 
  loading = false,
  loadingText = 'Loading...',
  disabled,
  fullWidth = false,
  wide = false,
  className = '',
  type = 'button',
  ...props 
}: PrimaryButtonProps) {
  // Handle sizing classes - adapt to ui-kit if needed
  const sizeClasses = fullWidth ? 'w-full max-w-[500px]' : wide ? 'w-48' : '';
  const combinedClassName = `flex items-center gap-2 ${sizeClasses} ${className}`.trim();
  
  return (
    <Button 
      {...props}
      variant="primary"
      type={type}
      disabled={disabled || loading}
      className={combinedClassName}
    >
      {loading && <span className="loading loading-spinner loading-sm"></span>}
      {loading ? loadingText : children}
    </Button>
  );
}

 